import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rcornersgrey mx-auto vstack",
  style: {"max-width":"800px","overflow":"initial"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "mt-3 required" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "actions w-100 mt-3 text-center hstack gap-2" }
const _hoisted_6 = ["href", "aria-disabled"]

import { computed, ref, watch } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import BFilterEditor from "../BFilterEditor/BFilterEditor.vue";
import {
    BFilter,
    BFilterOptions,
    BFilterableField,
} from "../BFilterEditor/BFilterEditor.types";

const dateFormat = "yyyy-MM-dd'";

export default /*@__PURE__*/_defineComponent({
  __name: 'DataExporter',
  props: {
    title: {},
    cancelUrl: {},
    submitUrl: {},
    exportUrl: {},
    filterableFields: {}
  },
  emits: ['submit','dateRangeUpdate','filterInfoUpdate'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit;

const errorText = ref("");
const ori = ref("");
var dateRangeFrom = ref([] as Date[]);
var filterInfo = ref({ filters: [] } as BFilterOptions);
var now = new Date(Date.now());
const maxDate = `${now.getUTCFullYear()}-${now.getUTCMonth() + 1}-${now.getUTCDate()}`;

const areFiltersValid = computed(() => {
    return filterInfo.value.filters.every((it) => it.property && it.operation && it.value)
})

const presetRanges = ref([
    {label:"Last 3 Months", range: [getCurrentDateMinusNAmountOfMonths(3), new Date(Date.now())]}, 
    {label:"Last 6 Months", range: [getCurrentDateMinusNAmountOfMonths(6), new Date(Date.now())]}]
);

const url = computed(() => {
    return `${props.submitUrl}${props.exportUrl}`;    
});

function handleDateRangeUpdate(e) {    
    for(var i = 0; i < e.length; i++){
        now = new Date(Date.now());
        if(e[i] == null){            
            e[i] = (i === 0) ? getCurrentDateMinusNAmountOfMonths(3): now;
        }
        
        dateRangeFrom.value[i] = e[i];          
    }
    return e;
}

function getCurrentDateMinusNAmountOfMonths(monthsToSubtract:number){
    let date = new Date();
    date.setMonth(date.getMonth() - monthsToSubtract);
    return date;
}

function addFilter() {
    var newFilter = {
        property: null,
        operation: null,
        value: null,
    } as BFilter;

    if (filterInfo.value) {
        filterInfo.value.filters = [...filterInfo.value.filters, newFilter];
    }
    emits('filterInfoUpdate',filterInfo.value);
}

function removeFilter(index: number) {
    if (filterInfo.value) {
        filterInfo.value.filters = filterInfo.value.filters.filter((it: any, ix: number) => ix != index);
    }
    emits('filterInfoUpdate',filterInfo.value);
}

function updateFilter(data: any) {
    if (data?.index > 0 && data?.filter != undefined) {
        filterInfo.value.filters[data.index] = data.filter;
    }
    emits('filterInfoUpdate',filterInfo.value);   
}

watch(
() => dateRangeFrom.value,
(val:any) => {
emits('dateRangeUpdate',val);
}
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("label", {
        id: "dateRange",
        class: "form-label mb-1 fw-bolder control-label"
      }, "Stop Date Range:", -1)),
      _createVNode(_unref(Datepicker), {
        modelValue: _unref(dateRangeFrom),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateRangeFrom) ? (dateRangeFrom).value = $event : dateRangeFrom = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (handleDateRangeUpdate($event)))
        ],
        format: dateFormat,
        clearable: false,
        required: "",
        "input-class-name": 'form-control',
        range: "",
        "aria-labelledby": "dateRange",
        "enable-time-picker": false,
        "max-date": new Date(Date.now()),
        "text-input": "",
        "partial-range": "",
        "prevent-min-max-navigation": "",
        "multi-calendars": 2,
        "multi-calendars-solo": "",
        "start-date": new Date(Date.now() - 2.6298e+9),
        "preset-ranges": presetRanges.value
      }, null, 8, ["modelValue", "max-date", "start-date", "preset-ranges"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Optional Filters:", -1)),
      _createVNode(BFilterEditor, {
        modelValue: _unref(filterInfo),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(filterInfo) ? (filterInfo).value = $event : filterInfo = $event)),
        ref: "filterEditor",
        value: _unref(filterInfo),
        fields: _ctx.filterableFields,
        onAddFilter: addFilter,
        onRemoveFilter: removeFilter,
        onUpdateFilter: updateFilter
      }, null, 8, ["modelValue", "value", "fields"])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "alert alert-danger mt-1",
      role: "alert"
    }, _toDisplayString(errorText.value), 513), [
      [_vShow, errorText.value != '']
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        href: url.value,
        class: _normalizeClass(["btn btn-primary", {'disabled':_unref(dateRangeFrom).length == 0 || !areFiltersValid.value}]),
        "aria-disabled": _unref(dateRangeFrom).length == 0,
        "aria-label": "submit",
        target: "_blank"
      }, "Export", 10, _hoisted_6)
    ])
  ]))
}
}

})